import React, { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Pages } from 'core/pages';

const Dashboard = lazy(() => import('./Dashboard'));
const List = lazy(() => import('./List'));
const Create = lazy(() => import('./Create'));
const ResourcePage = lazy(() => import('./ResourcePage'));
const Versions = lazy(() => import('./Versions'));
const Update = lazy(() => import('./Update'));

export function WebsiteRoutes() {
  return (
    <Routes>
      <Route path={Pages.cms.website.meta.path}>
        <Route
          index
          element={(<Dashboard />)}
        />
        <Route
          path={Pages.cms.website.list.meta.path}
          element={(<List />)}
        />
        <Route
          path={Pages.cms.website.create.meta.path}
          element={(<Create />)}
        />
        <Route
          path={Pages.cms.website.read.meta.path}
          element={(<ResourcePage />)}
        />
        <Route
          path={Pages.cms.website.versions.meta.path}
          element={(<Versions />)}
        />
        <Route
          path={Pages.cms.website.update.meta.path}
          element={(<Update />)}
        />
      </Route>
    </Routes>
  );
}
